

function randomString(length:number, chars = "a#") {
  if (typeof length !== "number" || length <= 0) {
    throw new Error("Length must be a positive integer.");
  }

  if (typeof chars !== "string") {
    throw new Error("Chars must be a string.");
  }

  let mask = '';
  if (chars.includes('a')) mask += 'abcdefghijklmnopqrstuvwxyz';
  if (chars.includes('A')) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  if (chars.includes('#') || chars.includes('1')) mask += '0123456789';
  if (chars.includes('!')) mask += '~`!@#$%^&*()_+-={}[]:";\'<>?,./|\\';

  if (mask.length === 0) {
    throw new Error("No valid characters specified in chars.");
  }

  let result = '';
  const randomIndex = (max:number) => Math.floor(Math.random() * max);

  for (let i = 0; i < length; i++) {
    result += mask[randomIndex(mask.length)];
  }

  return result;
}



export const randoms = {
  string: randomString
}